
import Vue from 'vue';
import { ClientConstants } from '../client.constants';
import { PvdModal } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';

export default Vue.extend({
    name: 'HeaderCard',
    props: {},
    data: () => {
        return {
            clientConstants: ClientConstants,
            modalContent: ClientConstants.LEARN_MORE_MODAL_SECTIONS,
        };
    },
    methods: {
        openLearnMore() {
            let modal = this.$refs['learn-modal'] as PvdModal;
            modal.pvdOpen = true;
        },
    },
});
